import DateTimeOrNoData from 'components/content/DateTimeOrNoData';
import NoData from 'components/content/NoData';
import type { FleetFE } from 'domain/systemAdmin';

import SidebarSection, { type SectionItem } from '../SidebarSection';
import SystemFleetsSidebarSection from './SystemFleetsSidebarSection';

interface Props {
    fleet?: FleetFE;
    vehicles: (string | undefined)[] | undefined;
    isLoading?: boolean;
}

const SystemFleetsSidebarContent = ({ fleet, vehicles, isLoading }: Props) => {
    const operationalItems: SectionItem[] = [
        {
            label: 'Team assigned',
            element: (
                <>
                    {fleet?.teams.length ? (
                        fleet.teams
                            .map(role => role.name)
                            .join(', ')
                            .toString()
                    ) : (
                        <NoData className='text-14' />
                    )}
                </>
            ),
        },
    ];

    const systemItems: SectionItem[] = [
        {
            label: 'Created',
            element: <DateTimeOrNoData value={fleet?.createdAt} separator />,
        },
        {
            label: 'ID',
            element: fleet?.id,
        },
    ];

    return (
        <div className='Sidebar__content'>
            <h4>{fleet?.name}</h4>
            <SystemFleetsSidebarSection header='Vehicles' icon='vehicle' items={vehicles} isLoading={isLoading} />
            <SidebarSection title='Operational' items={operationalItems} />
            <SidebarSection title='System' items={systemItems} />
        </div>
    );
};

export default SystemFleetsSidebarContent;
